import { render, staticRenderFns } from "./EditQuestions.vue?vue&type=template&id=6fd4ffb3&scoped=true&"
import script from "./EditQuestions.vue?vue&type=script&lang=js&"
export * from "./EditQuestions.vue?vue&type=script&lang=js&"
import style0 from "./EditQuestions.vue?vue&type=style&index=0&id=6fd4ffb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd4ffb3",
  null
  
)

export default component.exports